import React from 'react';
import { Link } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import { useAuth } from '../context/AuthContext';
import { WishlistButton } from '../system-modules/favorites/components';

export default function ProductCard({ product, hubId = null, hubName = null, hubSlug = null }) {
  const { addToCart } = useCart();
  const { user } = useAuth();

  const handleAddToCart = (e) => {
    e.preventDefault();
    e.stopPropagation();
    let source = null;
    let sourceName = '';

    if (hubId) {
      source = { type: 'hub', id: hubId, slug: hubSlug };
      sourceName = hubName || 'Hub';
    } else if (product.isHubDirect) {
      source = { type: 'hub', id: product.hubId, slug: product.hubSlug };
      sourceName = product.hubName || 'Hub';
    } else {
      source = { type: 'direct', id: product.producer?._id || product.producer, slug: product.producer?.slug };
      sourceName = product.producer?.farmName || product.producer?.name || 'Farm';
    }
    addToCart(product, 1, source, sourceName);
  };

  const isSeller = () => {
    if (!user) return false;
    const sellerId = hubId || product.hubId || product.producer?._id || product.producer;
    if (!sellerId) return false;
    return sellerId.toString() === user._id;
  };

  const availableQty = product.hubInventory !== undefined ? product.hubInventory : product.quantity;
  const isAvailable = availableQty > 0 && product.available !== false;

  const imageUrl = product.images && product.images[0] ? `/uploads/${product.images[0]}` : '/placeholder.jpg';
  const detailUrl = hubId ? `/product/${product._id}?hubId=${hubId}` : `/product/${product._id}`;

  let vendorText = '';
  if (hubId) {
    vendorText = hubName || 'Hub';
  } else if (product.isHubDirect) {
    vendorText = product.hubName || 'Hub';
  } else if (product.producer) {
    vendorText = product.producer.farmName || product.producer.name;
  }

  // Determine display prefix
  let displayPrefix = '';
  if (hubId) {
    // In hub storefront, everything is "Sold by: Hub Name"
    displayPrefix = 'Sold by: ';
  } else if (product.isHubDirect) {
    displayPrefix = 'Sold by: ';
  } else {
    displayPrefix = 'Grown by: ';
  }

  return (
    <Link to={detailUrl} className="block">
      <div className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition">
        <div className="h-48 overflow-hidden bg-gray-100 relative">
          <img src={imageUrl} alt={product.name} className="w-full h-full object-cover" onError={(e) => e.target.src = '/placeholder.jpg'} />
          {/* Wishlist Button - positioned top right */}
          <div className="absolute top-2 right-2" onClick={(e) => e.preventDefault()}>
            <WishlistButton productId={product._id} size="sm" />
          </div>
        </div>
        <div className="p-4">
          <h3 className="text-lg font-semibold mb-1">{product.name}</h3>
          <p className="text-gray-600 text-sm mb-2 line-clamp-2">{product.description}</p>

          <div className="text-sm text-gray-500 mb-2">
            {displayPrefix}{vendorText}
          </div>

          <div className="flex justify-between items-center">
            <span className="text-xl font-bold text-green-600">${product.price}/{product.unit}</span>
            {user && !isSeller() && isAvailable && (
              <button onClick={handleAddToCart} className="bg-green-600 text-white px-3 py-1 rounded hover:bg-green-700 text-sm">
                Add to Cart
              </button>
            )}
            {!isAvailable && <span className="text-red-500 text-sm">Out of stock</span>}
          </div>
        </div>
      </div>
    </Link>
  );
}
